export const listContentGenres = state => state.contentGenres.allContentGenres;

export const listContentGenresFromOrbitalPosition = () => [];

export const showContentGenre = (state, contentGenreId) => state.contentGenres.allContentGenres.find(cg => cg.id === contentGenreId);

export const getTotalCount = state => state.contentGenres.allContentGenres.filter(contentGenre => contentGenre.genre_type === "content").length;

export const listContentGenresFilters = state => state.contentGenres.filters;
